<template>
  <div
    class="file-item flex-row flex-left margin-bottom-10 clickable has-border__bottom"
    @click="click"
  >
    <i
      class="far fa-file color__link font-size__small margin-bottom-10 margin-right-10"
    ></i>
    <span
      :class="
        item.isSeen
          ? 'file-name  padding-bottom-10'
          : 'file-name  padding-bottom-10 font-weight__bold'
      "
      >{{ item.quote }}</span
    >
  </div>
</template>

<script>
export default {
  name: "doc-dashboard-card-item",
  props: ["item"],
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/doc-dashboard-card-item.vue